<template>
  <v-dialog v-model="parentPortalConfigurationOtherDialog" persistent>
    <v-card>
      <v-form ref="portalConfigurationFormRef">
        <v-card-title>
          <span class="headline">Configuration du portail</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-alert v-if="isBuiltIn" type="warning">
              Le portail a un template prédéfini
            </v-alert>
            <v-alert v-if="isInherit" type="warning">
              Le portail hérite des options du groupe
            </v-alert>

            <div id="portal-form" v-if="(isGroup && !isBuiltIn) || !isGroup">
              <v-row no-gutters v-if="!isInherit && !isBuiltIn">
                <v-col cols="12">
                  <v-checkbox
                    v-if="portalConfigurationModel.has_card_at_reception"
                    v-model="parentPortalConfiguration.has_card_at_reception"
                    label="Has Card At Reception ?"
                  ></v-checkbox>

                  <v-select
                    v-if="portalConfigurationModel.has_hide_access_codes"
                    v-model="parentPortalConfiguration.hide_access_codes"
                    :items="hide_access_codes"
                    item-value="value"
                    item-text="text"
                    label="Affichage saisie des codes d'accès"
                  ></v-select>

                  <v-divider></v-divider>
                </v-col>
              </v-row>

              <v-row v-if="portalConfigurationModel.user_form != null">
                <v-col cols="12">
                  <h3>Champs Formulaire</h3>
                  <v-row justify="space-around">
                    <v-col cols="12">
                      <header>Type</header>
                    </v-col>

                    <template
                      v-for="field in portalConfigurationModel.user_form"
                    >
                      <v-checkbox
                        :key="field"
                        v-model="parentPortalConfiguration.user_form"
                        :label="field"
                        :value="field"
                      ></v-checkbox>
                    </template>
                  </v-row>
                </v-col>
              </v-row>
              <v-row
                v-if="
                  portalConfigurationModel.has_ad != null &&
                  parentPortalConfiguration.ad != null
                "
              >
                <v-col cols="12">
                  <h3>Publicité</h3>

                  <v-checkbox
                    v-model="parentPortalConfiguration.ad.is_active"
                    label="Activer la publicité"
                  ></v-checkbox>

                  <div v-if="parentPortalConfiguration.ad.is_active == true">
                    <v-text-field
                      label="Groupname"
                      v-model="parentPortalConfiguration.ad.groupname"
                    ></v-text-field>

                    <v-text-field
                      label="Country"
                      v-model="parentPortalConfiguration.ad.country"
                    ></v-text-field>
                  </div>
                </v-col>
                <v-divider></v-divider>
              </v-row>
            </div>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="parentPortalConfigurationOtherDialog = false"
            >Fermer</v-btn
          >
          <v-btn
            color="blue darken-1"
            text
            @click="
              updatePortalConfiguration(
                id,
                parentPortalConfiguration,
                isInherit,
                isBuiltIn,
                portalProfile,
                portalConfigurationFormRef
              )
            "
            >Mettre à jour</v-btn
          >
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { computed, ref } from "@vue/composition-api";
import { usePortalConfiguration } from "@/composables/portal-configuration";

export default {
  props: {
    isInherit: Boolean,
    isBuiltIn: Boolean,
    portalOptionsId: Number,
    isGroup: Boolean,
    updatePortalConfiguration: Function,
    id: String,
    portalConfigurationModel: Object,
    group: Object,
    partner: Object,
    portalConfiguration: {
      type: Object,
      required: true,
    },
    portalConfigurationOtherDialog: Boolean,
    rules: Object,
  },
  setup(props, { emit }) {
    const parentPortalConfigurationOtherDialog = computed({
      get: () => props.portalConfigurationOtherDialog,
      set: (value) => {
        emit("update:portalConfigurationOtherDialog", value);
      },
    });

    const {
      initConfigurationForm,
      portalConfigurationFormRef,
      portalProfile,
    } = usePortalConfiguration();

    const parentPortalConfiguration = initConfigurationForm(props);

    const hide_access_codes = ref([
      { text: "0 - Afficher et déplier", value: 0 },
      { text: "1 - Ne pas afficher", value: 1 },
      { text: "2 - Afficher sans déplier", value: 2 },
    ]);
    return {
      parentPortalConfiguration,
      portalProfile,
      portalConfigurationFormRef,
      parentPortalConfigurationOtherDialog,
      hide_access_codes,
    };
  },
};
</script>
